var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"font-weight-bold px-2",attrs:{"label":"","x-small":"","color":_vm.bgColor,"text-color":_vm.textColor}},[_vm._v(" "+_vm._s(_vm.params.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }